import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  main: {
    position: "fixed",
    bottom: "0px",
    marginLeft: "180px",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",

    "& .vertical-line": {
      display: "block",
      width: "1px",
      height: "150px",
      backgroundColor: theme.palette.text.dark,
      margin: "10px 0px 0px 0px",

      [theme.breakpoints.down("xl")]: {
        height: "90px",
      },
    },
    "& img": {
      display: "block",
      width: "24px",
      margin: "0px 0px 20px 0px",
      transition: "all 0.2s",
      cursor: "pointer",
      filter: theme.palette.mode === "light"
        ? "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)"
        : "invert(74%) sepia(11%) saturate(585%) hue-rotate(188deg) brightness(95%) contrast(89%)",

      [theme.breakpoints.down("xl")]: {
        width: "35px",
      },

      "&:hover": {
        transform: "translateY(-4px)",
        filter: theme.palette.mode === "light"
          ? "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)"
          : "invert(80%) sepia(10%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(85%)",

      },
    },
  },
}));
